(function ClientTimeline($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		$("a.client-testimonials-view").on('click', function showInfo(e)
		{
			var $self = $(this);

			e.preventDefault();
			$modal.find('.modal-title').text($self.data("title"));
			$modal.find('.modal-body').html($self.data("testimonial"));
			$modal.modal('show');
		});

		$("a.client-testimonials-email-view").on('click', function showInfo(e)
		{
			var $self   = $(this);
			var content = $.parseJSON($(this).data('content')),
				iframe  = '<iframe id="message-body" style="width: 100%; height: 600px; border: none"></iframe>';

			e.preventDefault();

			$modal.find('.modal-title').text($self.data("title"));
			$modal.find('.modal-body').html(iframe);

			$('#message-body').prop('src', "data:text/html;charset=utf-8," + escape(content));
			
			$modal.modal('show');
		});

	});
}(jQuery, window.Adzuki || {}));